import { render, staticRenderFns } from "./wy-dialog.vue?vue&type=template&id=80f31b78&scoped=true&"
import script from "./wy-dialog.vue?vue&type=script&lang=js&"
export * from "./wy-dialog.vue?vue&type=script&lang=js&"
import style0 from "./wy-dialog.vue?vue&type=style&index=0&id=80f31b78&lang=scss&scoped=true&"
import style1 from "./wy-dialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f31b78",
  null
  
)

export default component.exports